import script from "./JaHomeHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./JaHomeHeader.vue?vue&type=script&setup=true&lang=js"

import "./JaHomeHeader.vue?vue&type=style&index=0&id=3c794447&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c794447"]])

export default __exports__